"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { keyMetrics as data } from "@/lib/data/demo";

const accents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)", "var(--color-amber)", "var(--color-rose)"];

export function KeyMetrics() {
  return (
    <Section id="key-metrics" className="relative">
      <Container>
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-10">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.metrics.map((m, i) => {
            const c = accents[i % accents.length]!;
            return (
              <Reveal key={m.label} delay={i * 80}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${c} 18%, transparent)` }}>
                  <div className="text-4xl font-bold" style={{ color: c }}>{m.value}</div>
                  <div className="mt-2 text-sm font-semibold uppercase tracking-wider" style={{ color: c }}>{m.label}</div>
                  <p className="mt-2 text-xs text-[rgb(var(--fg-muted))] leading-relaxed italic">{m.detail}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
